<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          v-if="params.context.parentComponent.permissions.view"
          depressed
          x-small
          class="secondary mr-2"
          v-on="on"
          v-bind="attrs"
          @click="viewItem"
        >
          <v-icon x-small color="white"> mdi-eye </v-icon>
        </v-btn>
      </template>
      <span> View</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          v-if="params.context.parentComponent.permissions.view"
          depressed
          x-small
          class="success mr-2"
          :disabled="params.data.is_approved || params.data.is_rejected"
          v-on="on"
          v-bind="attrs"
          @click="approveRequest"
        >
          <v-icon x-small color="white"> mdi-check </v-icon>
        </v-btn>
      </template>
      <span>{{ params.data.is_approved ? "Approved" : "Approve" }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          v-if="params.context.parentComponent.permissions.change"
          depressed
          x-small
          :disabled="params.data.is_approved || params.data.is_rejected"
          class="error mr-2"
          v-on="on"
          v-bind="attrs"
          @click="disApproveRequest"
        >
          <v-icon x-small color="white" v-bind="attrs"> mdi-close </v-icon>
        </v-btn>
      </template>
      <span>Reject</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    approveRequest() {
      this.params.context.parentComponent.approveLocationUpdate(
        this.params.data.id
      );
    },
    disApproveRequest() {
      this.params.context.parentComponent.disApproveLocationUpdate(
        this.params.data.id
      );
    },
    viewItem() {
      this.params.context.parentComponent.viewCustomerLocationUpdateDetails(
        this.params.data.id
      );
    },
  },
};
</script>

<style></style>
